<template>
  <v-data-table
    class="elevation-0"
    :headers="headers"
    :items="items"
    :mobile-breakpoint="0"
    :items-per-page="50"
    :footer-props="{
      'items-per-page-options': [10,50,100,-1],
      'items-per-page-all-text': $t('all'),
      'items-per-page-text': $t('items_per_page')
    }"

  >
    <template v-slot:[`header.heart`]="{}">&nbsp;</template>

    <template v-slot:item="{item}">
      <tr @click="()=>clickHandler(item)" class="product-table-item">
        <td>
          <div v-if="item.flower_specie.name" class="d-flex align-center">
            <img :src="image(item)" v-if="!mobile" class="ma-1" style="max-width:50px" />
            <div class="ml-2" style="white-space: nowrap;">
              <div style="font-size: 12px;">{{ item.flower_specie.flower_genus.name }}</div>
              <strong style="font-size: 12px; color: #212121;">{{ item.flower_specie.name }}</strong>
            </div>
          </div>
          <div v-else>{{ item.flower_specie }}</div>
        </td>
        <td>
          <span>{{ $d(item.earliest_delivery_date, 'shortDate') }}</span>
          <span>({{ $d(item.earliest_delivery_date, 'day') }})</span>
        </td>
        <td class="lowest_price">¥{{ $n(item.lowest_prices.sales_price) }}（内送料¥{{ $n(item.lowest_prices.delivery_fee) }}）</td>
        <td>
          <span style="font-size: 12px;">{{ item.farm.name }}</span>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { localeDate } from "@/plugins/i18n";

export default {
  props: {
    list: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      headers: [
        "flower_specie",
        "earliest_delivery_date",
        "lowest_price",
        "farm"
      ].map(x => ({
        text: this.$t(x),
        value: x,
        width: x === "heart" ? "30px" : "120px"
      })),
      mobile: this.$vuetify.breakpoint.xs
    };
  },

  methods: {
    clickHandler(flower) {
      if (flower) {
        this.$router.push(
          `/shop/products/${flower.id}`
        );
      }
    },
    image(flower) {
      return flower.thumbnail;
    }
  },

  computed: {
    items() {
      return this.list.map(x => ({
        ...x,
        earliest_delivery_date_label: x.earliest_delivery_date
          ? localeDate(x.earliest_delivery_date, "select")
          : "-",
        lowest_price: x.lowest_prices.sales_price,
        image_url: x.thumbnail,
        disabled: !!x.earliest_delivery_date
      }));
    }
  }
};
</script>

<style lang="scss">
.product-table-item{
  .lowest_price{
    white-space: nowrap;
  }
}
</style>
